import React, { useState } from "react";

const TabAndContentSection = ({ packageDetails, resourceKeys }) => {
  const [activeTab, setActiveTab] = useState("overview");
  const [expandedTabs, setExpandedTabs] = useState({});

  const tabs = [
    { id: "overview", label: resourceKeys.overview || 'Overview', content: packageDetails?.BasicInfo?.Overview },
    { id: "inclusion", label: resourceKeys.inclusion || "Inclusions", content: packageDetails?.BasicInfo?.Inclusion },
    { id: "exclusion", label: resourceKeys.exclusion || "Exclusions", content: packageDetails?.BasicInfo?.Exclusion },
    { id: "cancellation", label: resourceKeys.cancellation || "Cancellation", content: packageDetails?.BasicInfo?.CancellationPolicy },
  ];

  const toggleReadMore = (tabId) => {
    setExpandedTabs((prev) => ({
      ...prev,
      [tabId]: !prev[tabId],
    }));
  };

  const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "").trim();

  const renderTabContent = (content, isExpanded, maxLength = 200) => {
    if (!content) {
      return <p>No content available</p>;
    }

    const plainText = stripHtml(content);
    if (isExpanded || plainText.length <= maxLength) {
      return <div dangerouslySetInnerHTML={{ __html: content }} />;
    }

    return <p>{`${plainText.slice(0, maxLength)}...`}</p>;
  };

  return (
    <div className="col-lg-12">
      <div className="tab_wrap SPdetTab w-100">
        <nav>
          <div className="nav nav-tabs" role="tablist">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`nav-item nav-link ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
                role="tab"
                aria-controls={`nav-${tab.id}`}
                aria-selected={activeTab === tab.id}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </nav>
        <div className="tab-content">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={`tab-pane fade ${activeTab === tab.id ? "show active" : ""}`}
              id={`nav-${tab.id}`}
              role="tabpanel"
            >
              {renderTabContent(tab.content, expandedTabs[tab.id])}
              {tab.content && stripHtml(tab.content).length > 200 && (
                <p>
                  <a
                    onClick={() => toggleReadMore(tab.id)}
                  >
                    {expandedTabs[tab.id] ? resourceKeys.read_less || "Read Less" : resourceKeys.read_more || "Read More"}
                  </a>
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabAndContentSection;
